import PosJournalList from "../component/PosJournalList";
import React from "react";

const PosJournalListContainer = ({ pageId }) => (<PosJournalList pageId={ pageId } />)

export default PosJournalListContainer;